import React, { useState } from 'react';
import { Button } from '@wfp/ui';

import { WarningEvent, WarningEventStatus } from '../../../restapi/types';
import { isFirstEvent, userCanComment } from '../../../restapi/warningEvent';
import { CommentsMark } from './CommentsMark';
import { CommentsStatus, commentsStatusLabel, messageWithHeader } from './types';
import { EditComment } from './EditComment';
import { useEWUser } from '../../../hooks/home';

import "./CommentsBox.scss";


interface Props {
	event: WarningEvent;
}

export function CommentsBox({event}: Props) {
	const user = useEWUser();
	const [modalOpen, setModalOpen] = useState(false);

	const approved = event.status === WarningEventStatus.approved;
	const hasComment = !!event.comment?.message;
	const content = hasComment ? messageWithHeader(event.comment!) :
		`No comment for this ${isFirstEvent(event) ? 'warning' : 'update'}`;

	if (!user) {
		return null;
	}

	const canComment = !approved && userCanComment(user);

	return <div className="comments-box">
		{hasComment ?
			<div>
				<h4>
					{canComment && <div className="fright">
						<Button kind="primary" small
								onClick={() => setModalOpen(true)}>Edit</Button>
					</div>}
					<CommentsMark event={event}/>
					{commentsStatusLabel[event.comment!.isOpen ? CommentsStatus.open : CommentsStatus.done]}
				</h4>
				<div className="doc-fragment"
					 dangerouslySetInnerHTML={{__html: content || ''}}/>
			</div>
			: <CommentsMark event={event} active/>
		}
		{modalOpen &&
			<EditComment event={event}
						 onClose={() => setModalOpen(false)}
			/>}
	</div>;
}
